import { Extension } from '@tiptap/core';

import { TABLE_SECTION_ATTRIBUTE } from './table-markup-extension';

/**
 * The data-* attributes a document carries survive a round trip through the editor as one
 * attribute bag. Writers hang hooks for their own stylesheets on them, and the schema knows
 * none of them by name.
 */
const CARRIED_TYPES = [
  'div',
  'textDiv',
  'section',
  'span',
  'paragraph',
  'heading',
  'table',
  'tableRow',
  'tableCell',
  'tableHeader',
  'listItem',
  'bulletList',
  'orderedList',
  'blockquote'
];

/** Attributes another extension, or the editor's own chrome, owns. */
const OWNED = new Set([
  'data-page-break',
  'data-colwidth',
  'data-cara-probe',
  TABLE_SECTION_ATTRIBUTE
]);

const isCarried = (name: string) =>
  name.startsWith('data-') && !name.startsWith('data-editor-') && !OWNED.has(name);

export const DataAttributesExtension = Extension.create({
  name: 'dataAttributes',

  addGlobalAttributes() {
    return [
      {
        types: CARRIED_TYPES,
        attributes: {
          dataset: {
            default: null as Record<string, string> | null,
            parseHTML: (element: HTMLElement) => {
              const carried: Record<string, string> = {};
              for (const { name, value } of Array.from(element.attributes)) {
                if (isCarried(name)) carried[name] = value;
              }
              return Object.keys(carried).length > 0 ? carried : null;
            },
            renderHTML: (attributes: Record<string, unknown>) =>
              (attributes.dataset as Record<string, string> | null) ?? {}
          }
        }
      }
    ];
  }
});
